@if(url) {
@if(!failedImage()) {
<img
  [src]="url"
  [alt]="name"
  class="rounded-full object-cover"
  [ngClass]="sizeClasses()"
  (error)="onImageError()">
} @else {
<div class="rounded-full flex items-center justify-center font-bold uppercase bg-slate-500/10 text-slate-600 dark:bg-dark-500 dark:text-gray-600"
     [ngClass]="sizeClasses()">
  {{ getInitial() }}
</div>
}
} @else {
<div class="rounded-full flex items-center justify-center font-bold uppercase bg-slate-500/10 text-slate-600 dark:bg-dark-500 dark:text-gray-600"
     [ngClass]="sizeClasses()">
  {{ getInitial() }}
</div>
}
